import { MapPin, Mail } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const legalLinks = [
    { label: "Termos de Uso", href: "#terms" },
    { label: "Política de Privacidade", href: "#privacy" },
    { label: "LGPD", href: "#lgpd" },
    { label: "Contato", href: "#contact" },
  ];

  return (
    <footer className="bg-[#0A0B0E] border-t border-[#2A2F38]" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div>
            <h3 className="font-heading text-2xl font-bold mb-4">
              <span className="text-[#F59E0B]">Kp</span>
              <span className="text-[#E5E7EB]">Action</span>
            </h3>
            <p className="text-[#9CA3AF] text-sm mb-4">
              Inteligência operacional para empresas que buscam crescimento estruturado.
            </p>
            <p className="text-xs text-[#6B7280]">
              © {currentYear} Todos os direitos reservados.
            </p>
          </div>

          {/* Company Info */}
          <div>
            <h4 className="font-heading text-lg font-bold text-[#E5E7EB] mb-4 uppercase tracking-wider">
              Empresa
            </h4>
            <div className="space-y-3 text-sm">
              <p className="text-[#E5E7EB]">EVIDENTIA TECNOLOGIA LTDA</p>
              <p className="text-[#9CA3AF]">CNPJ: 65.097.807/0001-30</p>
              <div className="flex items-start gap-2 text-[#9CA3AF]">
                <MapPin className="h-4 w-4 text-[#F59E0B] flex-shrink-0 mt-0.5" />
                <span>
                  Av. Raimundo Pereira de Magalhães, 1652
                  <br />
                  Apt 42 Bloco II
                  <br />
                  Jardim Iris — São Paulo/SP
                </span>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-bold text-[#E5E7EB] mb-4 uppercase tracking-wider">
              Contato
            </h4>
            <div className="space-y-3 text-sm">
              <a
                href="mailto:contato@kpaction.com.br"
                className="flex items-center gap-2 text-[#9CA3AF] hover:text-[#F59E0B] transition-colors"
              >
                <Mail className="h-4 w-4 text-[#F59E0B]" />
                contato@kpaction.com.br
              </a>
              <a
                href="https://www.kpaction.com.br"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#9CA3AF] hover:text-[#F59E0B] transition-colors"
              >
                www.kpaction.com.br
              </a>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="h-px bg-[#2A2F38] mb-8" />

        {/* Legal Section */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-[#6B7280]">
            Marca de titularidade da EVIDENTIA TECNOLOGIA LTDA
          </p>
          <div className="flex flex-wrap justify-center gap-6">
            {legalLinks.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className="text-xs text-[#6B7280] hover:text-[#F59E0B] transition-colors uppercase tracking-wider"
                data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        {/* Terms Text */}
        <div className="mt-12 pt-8 border-t border-[#2A2F38]">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 text-xs text-[#6B7280]">
            {/* Terms */}
            <div id="terms">
              <h5 className="font-bold text-[#9CA3AF] mb-2 uppercase tracking-wider">
                Termos e Condições
              </h5>
              <p className="leading-relaxed">
                A licença é: Anual, Individual, Intransferível, Vinculada à chave de ativação.
                O uso indevido ou redistribuição não autorizada implica cancelamento da licença.
              </p>
            </div>

            {/* Privacy */}
            <div id="privacy">
              <h5 className="font-bold text-[#9CA3AF] mb-2 uppercase tracking-wider">
                Política de Privacidade
              </h5>
              <p className="leading-relaxed">
                O KpAction não coleta dados operacionais. Dados de cadastro são utilizados
                exclusivamente para comunicação, emissão fiscal e suporte técnico.
                Conformidade integral com a Lei Geral de Proteção de Dados.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
